import person1 from '../assets/person1.png';
import person2 from '../assets/person2.png';
import person3 from '../assets/person3.png';


export const teamMembers = [
 {
    name: "Adv. Pintu Arjun Yadav",
    designation: "Founder & Lead Advocate",
    qualification: "M.COM, BBI, LL.B",
    experience: "8+ Years",
    specialization: "Criminal & Civil Litigation",
    image: person1,
    bio: "Adv. Pintu Arjun Yadav brings a unique combination of financial literacy and legal expertise. With a background in Commerce and Law, he provides strategic counsel that aligns legal solutions with business objectives.",
    email: "akylegalconsultants@gmail.com",
    phone: "+91 97694 15432"
  },
  {
    name: "Adv. Biswa Ranjan Palo",
    designation: "Senior Associate",
    qualification: "M.com, LLB",
    experience: "1+ Years",
    specialization: "Advocate Bombay High Court",
    image: person2,
    bio: "Adv. Biswa Ranjan Palo specializes in Trademark, Society matters, family law matters with a compassionate approach. He has successfully handled numerous divorce, child custody, and domestic violence cases.",
    email: "akylegalconsultants@gmail.com",
    phone: "+91 97694 15432"
  },
  {
    name: "ADV. Mohammed Fareeduddin Siddiqui",
    designation: "Senior Associate",
    qualification: "LL.M, LL.B",
    experience: "3+ Years",
    specialization: "Criminal and Civil",
    image: person3,
    bio: "Adv. Mohammed Fareeduddin Siddiqui is a dedicated legal professional specializing in Civil and Criminal Law. He is committed to delivering high-quality legal solutions tailored to the unique circumstances of each case. Known for his compassionate approach, he strives to alleviate the stress of legal proceedings by maintaining transparent communication and providing steadfast support, ensuring his clients feel understood and confident every step of the way.",
     email: "akylegalconsultants@gmail.com",
    phone: "+91 97694 15432"
  }
  
];